<table
  mat-table
  [dataSource]="dataSource"
  matSort
  matSortActive="priority"
  matSortDirection="asc"
>
    <ng-container *ngFor="let column of displayedColumns" matColumnDef="{{column}}">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ column | replaceunderscore | uppercase }}
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row[column] }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
